import { Create, Delete } from '@mui/icons-material';
import {
    Box,
    Button,
    IconButton,
    Paper,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tabs
} from '@mui/material';
import React from 'react';
import { IParametroSistema } from '../../modelo/ParametroSistema';

import { observer } from 'mobx-react';
import './css/TabelaParametrosSistemaStyles.css';
import { action, observable, makeObservable } from "mobx";

export interface IPropsTabelaParametrosSistema {
    parametros?: IParametroSistema[];

    parametrosUsuario?: any;

    editar?(parametro: IParametroSistema);

    excluir?(parametro: IParametroSistema);

    abrirModalInclusaoEdicao(abrir: boolean);

    irParaTelaPrincipal();

    titulo?: string;
}

class TabelaParametrosSistema extends React.Component<IPropsTabelaParametrosSistema> {

    abaSelecionada: number = 0;

    handleMudaAba = (e: React.MouseEvent, novaAbaSelecionada: number) => {
        this.abaSelecionada = novaAbaSelecionada;
    };

    get categoriasParametro() {
        if (!this.props.parametros) return [];
        
        const categoriasMap = new Map(
            this.props.parametros
                .filter(parametro => parametro.categoria != null)
                .map(parametro => [parametro.categoria.codigo, parametro.categoria])
        );
        
        return Array.from(categoriasMap.values()).sort((a, b) => a.codigo - b.codigo);
    }

    constructor(props) {
        super(props);

        makeObservable(this, {
            abaSelecionada: observable,
            handleMudaAba: action,
});
    }

    render() {
        const categorias = this.categoriasParametro;

        return (
            <>
                <Paper sx={{ padding: 5, paddingBottom: 0 }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs
                            value={this.abaSelecionada}
                            onChange={this.handleMudaAba}
                            indicatorColor="primary"
                        >
                            {categorias
                                .map((categoria, _index) =>
                                        <Tab key={categoria.codigo} label={categoria.descricao} style={{ margin: 0 }}>
                                        </Tab>
                                )}
                        </Tabs>
                    </Box>
                </Paper>
                {categorias.map((categoria, indiceCategoria) =>
                    <React.Fragment key={categoria.codigo}>
                        {this.abaSelecionada === indiceCategoria &&
                            <>
                                <Paper style={{ padding: '16px', marginTop: '8px' }}>
                                    <h3 style={{ marginLeft: 10, margin: '0' }}>
                                        {this.props.titulo || 'Parâmetros do sistema - ' + categoria.descricao}
                                    </h3>
                                </Paper>
                                <Paper style={{ padding: 5, maxHeight: 'calc(100vh - 350px)', overflow: 'auto', marginTop: '8px' }}>
                                    <Table stickyHeader aria-label="sticky table" style={{ tableLayout: 'fixed', width: '100%' }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell style={{ width: '25%', fontWeight: 'bold' }}>Nome</TableCell>
                                                <TableCell style={{ width: '35%', fontWeight: 'bold' }}>Descrição</TableCell>
                                                <TableCell style={{ width: '25%', fontWeight: 'bold' }}>Valor</TableCell>
                                                <TableCell style={{ width: '15%', fontWeight: 'bold' }}>Ações</TableCell>
                                            </TableRow>
                                        </TableHead>
                                            <TableBody>
                                                {this.props.parametros && this.props.parametros
                                                    .filter(parametro => {
                                                        if (categoria.codigo === 100) {
                                                            // Categoria Geral: inclui parâmetros sem categoria ou com categoria 100
                                                            return !parametro.categoria || parametro.categoria.codigo === 100;
                                                        } else {
                                                            // Outras categorias: usa a categoria específica
                                                            return parametro.categoria && parametro.categoria.codigo === categoria.codigo;
                                                        }
                                                    })
                                                    .sort((a, b) => a.id - b.id)
                                                    .map((parametro, index) =>
                                                            <TableRow key={index}>
                                                                <TableCell>{parametro.nome}</TableCell>
                                                                <TableCell>{parametro.descricao}</TableCell>
                                                                <TableCell style={{ wordBreak: 'break-word' }}>{parametro.valor}</TableCell>
                                                                <TableCell id={'acoesParametroSistema' + index}>
                                                                    <span title="Editar Parâmetro">
                                                                        <IconButton className="botao-add" size="small"
                                                                                    onClick={this.props.editar.bind(this, parametro)}>
                                                                            <Create fontSize="small" />
                                                                        </IconButton>
                                                                    </span>
                                                                                                <span title="Excluir Parâmetro">
                                                                        <IconButton className="botao-rm" size="small"
                                                                                    onClick={this.props.excluir.bind(this, parametro)}>
                                                                            <Delete fontSize="small" />
                                                                        </IconButton>
                                                                    </span>
                                                                </TableCell>
                                                            </TableRow>
                                                    )}
                                            </TableBody>
                                    </Table>
                                </Paper>
                            </>
                        }
                    </React.Fragment>
                )}
                
                <Paper style={{ padding: '16px', marginTop: '8px' }}>
                    <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-start' }}>
                        <Button id='botaoAdicionarParametro'
                                color="primary"
                                variant="contained"
                                onClick={this.props.abrirModalInclusaoEdicao.bind(this, true)}
                                title={'Adicionar Parâmetro'}
                        >
                            Novo Parâmetro
                        </Button>
                        <Button color="secondary"
                                variant="outlined"
                                onClick={this.props.irParaTelaPrincipal.bind(this)}
                                title={'Sair'}
                        >
                            Voltar
                        </Button>
                    </div>
                </Paper>
            </>
        );
    }
}

export default observer(TabelaParametrosSistema);
